import React, { useState } from "react";
import styles from "./ui.module.css";

const InputField = ({
  type,
  label,
  value,
  onChange,
  required = false,
  isEditing = false,
  placeholder = "",
  error = "",
  backColor = "white"
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper}>
        <input
          type={type}
          value={value}
          onChange={onChange}
          required={required}
          placeholder={isFocused ? "" : label}
          className={`${styles.input} ${error ? styles.inputError : ""}`}
          disabled={isEditing}
          onFocus={() => setIsFocused(true)}
          onBlur={() => !value && setIsFocused(false)}
          style={backColor && backColor !== "white" ? { backgroundColor: backColor } : {}}
        />
        <label style={{ backgroundColor: backColor }}
          className={`${styles.label} ${
            isFocused || value ? styles.labelFloating : ""
          }`}
        >
          {label}
        </label>
      </div>
      {error && <span className={styles.errorMessage}>{error}</span>}
    </div>
  );
};

export default InputField;